import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk'; // ✅ FIXED import

import reducer from './rootReducer';

const store = createStore(reducer, applyMiddleware(thunk));
export default store;
